import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';

// Türkçe karakterleri ASCII karşılıklarıyla değiştiren fonksiyon
const turkishToAscii = (text) => {
  if (!text) return '';
  return text
    .replace(/İ/g, 'I')
    .replace(/ı/g, 'i')
    .replace(/Ğ/g, 'G')
    .replace(/ğ/g, 'g')
    .replace(/Ü/g, 'U')
    .replace(/ü/g, 'u')
    .replace(/Ş/g, 'S')
    .replace(/ş/g, 's')
    .replace(/Ö/g, 'O')
    .replace(/ö/g, 'o')
    .replace(/Ç/g, 'C')
    .replace(/ç/g, 'c');
};

export const generateTicketPDFFromTemplate = async (ticketData, getStatusText, translateKind) => {
  try {
    // Yeni PDF dokümanı oluştur (izin formu template'i temel alınarak)
    const pdfDoc = await PDFDocument.create();
    const page = pdfDoc.addPage([595, 842]); // A4 boyutu
    const { width, height } = page.getSize();
    
    // Embed fonts - Türkçe karakter desteği için
    // StandardFonts Türkçe karakterleri desteklemediği için basit ASCII karakterler kullanacağız
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    
    // Colors - İzin formundaki renk şemasını taklit et
    const primaryColor = rgb(0.2, 0.2, 0.2); // Koyu gri
    const textColor = rgb(0.1, 0.1, 0.1);
    const headerColor = rgb(0.8, 0.1, 0.1); // Kırmızı ton
    const lightGray = rgb(0.95, 0.95, 0.95);
    const borderColor = rgb(0.7, 0.7, 0.7);
    
    let yPosition = height - 50;
    
    // Header - Şirket bilgileri (izin formundaki gibi)
    page.drawText(turkishToAscii('GST ELEKTRONIK A.S.'), {
      x: 50,
      y: yPosition,
      size: 18,
      font: boldFont,
      color: headerColor,
    });
    
    page.drawText(turkishToAscii('TEKNIK DESTEK TALEBI'), {
      x: 350,
      y: yPosition,
      size: 16,
      font: boldFont,
      color: primaryColor,
    });
    
    yPosition -= 30;
    
    // Çizgi çek
    page.drawLine({
      start: { x: 50, y: yPosition },
      end: { x: width - 50, y: yPosition },
      thickness: 2,
      color: borderColor,
    });
    
    yPosition -= 40;
    
    // Ticket başlık bilgileri - Tablo formatında
    const drawTableRow = (label, value, y, isHeader = false) => {
      const bgColor = isHeader ? lightGray : rgb(1, 1, 1);
      const textFont = isHeader ? boldFont : font;
      const fontSize = isHeader ? 12 : 11;
      
      // Arka plan
      page.drawRectangle({
        x: 50,
        y: y - 5,
        width: width - 100,
        height: 20,
        color: bgColor,
        borderColor: borderColor,
        borderWidth: 1,
      });
      
      // Label
      page.drawText(turkishToAscii(label), {
        x: 60,
        y: y,
        size: fontSize,
        font: textFont,
        color: textColor,
      });
      
      // Value
      if (value) {
        page.drawText(turkishToAscii(value), {
          x: 250,
          y: y,
          size: fontSize,
          font: font,
          color: textColor,
        });
      }
      
      return y - 25;
    };
    
    // Ticket bilgileri tablosu
    yPosition = drawTableRow('TICKET BILGILERI', '', yPosition, true);
    yPosition = drawTableRow('Ticket No', `#${ticketData.number}`, yPosition);
    yPosition = drawTableRow('Durum', getStatusText(ticketData.state), yPosition);
    yPosition = drawTableRow('Tur', translateKind(ticketData.kind), yPosition);
    yPosition = drawTableRow('Olusturulma Tarihi', new Date(ticketData.created_at).toLocaleString('tr-TR'), yPosition);
    
    if (ticketData.started_at) {
      yPosition = drawTableRow('Baslatilma Tarihi', new Date(ticketData.started_at).toLocaleString('tr-TR'), yPosition);
    }
    
    if (ticketData.completed_at) {
      yPosition = drawTableRow('Tamamlanma Tarihi', new Date(ticketData.completed_at).toLocaleString('tr-TR'), yPosition);
    }
    
    yPosition -= 20;
    
    // Müşteri bilgileri tablosu
    yPosition = drawTableRow('MUSTERI BILGILERI', '', yPosition, true);
    yPosition = drawTableRow('Ad Soyad', ticketData.full_name || 'Belirtilmemis', yPosition);
    yPosition = drawTableRow('Telefon', ticketData.phone_number || 'Belirtilmemis', yPosition);
    yPosition = drawTableRow('E-posta', ticketData.email || 'Belirtilmemis', yPosition);
    yPosition = drawTableRow('Sehir', ticketData.city || 'Belirtilmemis', yPosition);
    yPosition = drawTableRow('Adres', ticketData.address || 'Belirtilmemis', yPosition);
    
    yPosition -= 20;
    
    // Arıza açıklaması bölümü
    yPosition = drawTableRow('ARIZA ACIKLAMASI', '', yPosition, true);
    yPosition -= 10;
    
    // Açıklama kutusu
    const descriptionBoxHeight = 100;
    page.drawRectangle({
      x: 50,
      y: yPosition - descriptionBoxHeight,
      width: width - 100,
      height: descriptionBoxHeight,
      color: rgb(1, 1, 1),
      borderColor: borderColor,
      borderWidth: 1,
    });
    
    // Açıklama metni (satır satır böl)
    const description = turkishToAscii(ticketData.body || 'Aciklama bulunmuyor.');
    const maxWidth = width - 120;
    const words = description.split(' ');
    let line = '';
    let lineY = yPosition - 20;
    
    for (const word of words) {
      const testLine = line + word + ' ';
      const textWidth = font.widthOfTextAtSize(testLine, 11);
      
      if (textWidth > maxWidth && line !== '') {
        page.drawText(line.trim(), {
          x: 60,
          y: lineY,
          size: 11,
          font: font,
          color: textColor,
        });
        line = word + ' ';
        lineY -= 15;
        
        if (lineY < yPosition - descriptionBoxHeight + 10) break; // Kutu sınırını aşma
      } else {
        line = testLine;
      }
    }
    
    if (line.trim() !== '' && lineY >= yPosition - descriptionBoxHeight + 10) {
      page.drawText(line.trim(), {
        x: 60,
        y: lineY,
        size: 11,
        font: font,
        color: textColor,
      });
    }
    
    yPosition -= descriptionBoxHeight + 30;
    
    // İmza bölümü (izin formundaki gibi)
    const signatureY = 150;
    
    // Personel imzası
    page.drawText(turkishToAscii('PERSONEL IMZASI'), {
      x: 80,
      y: signatureY + 30,
      size: 10,
      font: boldFont,
      color: textColor,
    });
    
    page.drawLine({
      start: { x: 80, y: signatureY },
      end: { x: 200, y: signatureY },
      thickness: 1,
      color: borderColor,
    });
    
    page.drawText(turkishToAscii('Ad Soyad:'), {
      x: 80,
      y: signatureY - 15,
      size: 9,
      font: font,
      color: textColor,
    });
    
    page.drawText(turkishToAscii('Tarih:'), {
      x: 80,
      y: signatureY - 30,
      size: 9,
      font: font,
      color: textColor,
    });
    
    // Müşteri imzası
    page.drawText(turkishToAscii('MUSTERI IMZASI'), {
      x: 350,
      y: signatureY + 30,
      size: 10,
      font: boldFont,
      color: textColor,
    });
    
    page.drawLine({
      start: { x: 350, y: signatureY },
      end: { x: 470, y: signatureY },
      thickness: 1,
      color: borderColor,
    });
    
    page.drawText(turkishToAscii('Ad Soyad:'), {
      x: 350,
      y: signatureY - 15,
      size: 9,
      font: font,
      color: textColor,
    });
    
    page.drawText(turkishToAscii('Tarih:'), {
      x: 350,
      y: signatureY - 30,
      size: 9,
      font: font,
      color: textColor,
    });
    
    // Footer
    page.drawText(turkishToAscii(`Bu belge ${new Date().toLocaleString('tr-TR')} tarihinde sistem tarafindan olusturulmustur.`), {
      x: 50,
      y: 50,
      size: 8,
      font: font,
      color: rgb(0.5, 0.5, 0.5),
    });
    
    page.drawText(turkishToAscii('GST Elektronik A.S. - Teknik Destek Birimi'), {
      x: 50,
      y: 35,
      size: 8,
      font: font,
      color: rgb(0.5, 0.5, 0.5),
    });
    
    // Save and download PDF
    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    link.download = `ticket-${ticketData.number}-destek-talebi.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
  } catch (error) {
    console.error('PDF oluşturma hatası:', error);
    throw error;
  }
};

export default generateTicketPDFFromTemplate;